<template>
  <v-row>
    <v-col cols="12">
      <div v-for="(financialAsset, index) in financialAssets" :key="index">
        <div class="list-item">
          <v-btn
            class="list-item-btn"
            :ripple="false"
            block
            color="white"
            @click.stop="
              (showDialog = true), (financialAssetToUpdate = financialAsset)
            "
          >
            <div class="list-item-text">
              <span class="list-item-name">{{
                financialAssetListName(financialAsset)
              }}</span>
              <span class="list-item-separator">-</span>
              <span class="list-item-more-info">{{
                financialAsset.institution
              }}</span>
            </div>
          </v-btn>
        </div>
      </div>
      <div class="mt-5 mb-5">
        <AlternativeButton
          :title="'Add Financial Asset'"
          @gradientButtonClicked="addFinancialAssetClicked"
        />
      </div>
    </v-col>
    <FinancialAssetDialog
      v-model="showDialog"
      :financial-asset-to-update="financialAssetToUpdate"
    />
  </v-row>
</template>

<script>
  import FinancialAssetDialog from './FinancialAssetDialog.vue';
  import { financialAssetType } from '../../constants/js/financial-assets';

  export default {
    name: 'FinancialAssetsList',
    components: {
      FinancialAssetDialog,
    },
    props: {
      financialAssets: {
        required: true,
        type: Array,
      },
    },
    data() {
      return {
        showDialog: false,
        financialAssetToUpdate: {},
      };
    },
    methods: {
      addFinancialAssetClicked() {
        this.financialAssetToUpdate = {};
        this.showDialog = true;
        this.sendGADataLayer('add-investment');
      },
      sendGADataLayer(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: event,
          omuserid: this.$store.getters?.userId,
        });
      },
      financialAssetListName(financialAsset) {
        return financialAssetType(financialAsset);
      },
    },
  };
</script>

<style scoped lang="scss"></style>
